module.exports = __webpack_public_path__ + "static/media/WoltersKluwer-logo.99c58b1a.png";